import React, { useRef, useEffect, useContext } from 'react';

// Components
import Hero from '../../../components/advanced/hero/Hero';
import ProfileBadge from '../../../components/advanced/profileBadge/ProfileBadge';
import Notification from './components/notification/Notification';
import Tooltip from '../../../components/advanced/tooltip/Tooltip';

// Libraries
import { Container, MagicModal } from '@hybris-software/ui-kit';
import { useUser, PermissionRoute } from '@hybris-software/use-auth';
import useQuery from '@hybris-software/use-query';
import { useNavigate } from 'react-router-dom';

// Svgs
import Copy from '../../../assets/svgs/Copy';

// Hooks
import useText from '../../../hooks/useText';

// Utils
import dispatcher from '../../../utils/dispatcher';

// Data
import endpoints from '../../../data/endpoints';
import config from '../../../data/config';

// Contexts
import { RoutesContext } from '../../../contexts/RoutesContext';

// Styles
import Style from './NotificationView.module.css';

const NotificationView = () => {
	// Hooks
	const copy = useText('copyTooltip');
	const texts = useText('notificationView');
	const navigate = useNavigate();
	const { userInfo } = useUser();
	// Refs
	const modalRef = useRef();
	// Contexts
	const { paths } = useContext(RoutesContext);

	const getNotificationSettingsApi = useQuery({
		url: endpoints.profile.NOTIFICATIONSETTINGS,
		method: 'GET',
		executeImmediately: true,
	});

	useEffect(() => {
		document.title = `${config.PLATFORM_NAME} | ${texts?.pageTitle}`;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<PermissionRoute
			// loader={<Loader />}
			minimumLoadingTime={500}
			forLoggedUser={true}
			firstApiLoading={getNotificationSettingsApi.isLoading}
			unAuthorizedAction={() => {
				navigate(paths.auth.login);
			}}
			permissionController={(response) => {
				dispatcher(response.data, navigate, paths);
				return true;
			}}
		>
			<MagicModal ref={modalRef} />

			<Hero>
				<Container>
					<div className={Style.header}>
						<h3 className={Style.title}>{texts?.title}</h3>
						<div className={Style.referral}>
							<div className={Style.referralText}>
								{texts?.cardReferral}{' '}
								{`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'}
							</div>

							<Tooltip
								valueToCopy={
									`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'
								}
								copyIcon={<Copy />}
								textCopy={copy?.copied}
							/>
						</div>
					</div>
					<ProfileBadge modalRef={modalRef} />
				</Container>
			</Hero>

			<Container>
				<Notification
					modalRef={modalRef}
					response={getNotificationSettingsApi?.response?.data}
				/>
			</Container>
		</PermissionRoute>
	);
};

export default NotificationView;
